document.addEventListener('DOMContentLoaded', function() {
  const medias = document.querySelectorAll('.media')
  const btnUp = document.querySelector('.product-media__gallery-button.up')
  const btnDown = document.querySelector('.product-media__gallery-button.down')
  const btnNext = document.querySelector('.product-media__featured-button.right')
  const btnPrev = document.querySelector('.product-media__featured-button.left')
  const featuredWrapper = document.querySelector('.product-media__featured-main-image')

  const totalMedia = medias.length
  const visibleCount = 5
  let startIndex = 0
  let activeIndex = 0
  let visibleMedia = []

  function updateCounter() {
    const counterCurrent = document.querySelector(
      '.product-media__featured-main-image-counter-current'
    )

    if (counterCurrent) {
      counterCurrent.textContent = activeIndex + 1
    }
  }

  function findMatchingMediaByVariantImage(variantImageUrl) {
    if (!variantImageUrl) return -1

    const variantFilename = variantImageUrl.split('/').pop().split('?')[0]
    const variantBaseFilename = variantFilename.replace(
      /_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i,
      '.$1'
    )

    for (let i = 0; i < medias.length; i++) {
      const media = medias[i]
      const mediaSrc = media.dataset.mediaSrc

      if (mediaSrc) {
        const mediaFilename = mediaSrc.split('/').pop().split('?')[0]
        const mediaBaseFilename = mediaFilename.replace(
          /_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i,
          '.$1'
        )

        if (mediaFilename === variantFilename) {
          return i
        }

        if (
          variantBaseFilename &&
          mediaBaseFilename &&
          mediaBaseFilename === variantBaseFilename
        ) {
          return i
        }

        if (mediaFilename.includes(variantBaseFilename.split('.')[0])) {
          return i
        }
      }
    }

    return -1
  }

  function setActiveMedia(index) {
    if (index >= 0 && index < totalMedia) {
      activeIndex = index

      if (activeIndex < startIndex) {
        startIndex = activeIndex
      } else if (activeIndex >= startIndex + visibleCount) {
        startIndex = Math.max(0, activeIndex - visibleCount + 1)
      }

      updateVisibleMedia()
    }
  }

  function updateFeaturedMedia() {
    if (!featuredWrapper) return

    const activeMedia = medias[activeIndex]
    if (!activeMedia) return

    const mediaType = activeMedia.dataset.mediaType
    const mediaSrc = activeMedia.dataset.mediaSrc
    const mediaAlt =
      activeMedia.dataset.mediaAlt || 'Featured product media'

    const existingMedia = featuredWrapper.querySelector('#featuredMedia')
    const existingType = existingMedia
      ? existingMedia.tagName === 'VIDEO'
        ? 'video'
        : 'image'
      : null

    if (existingMedia && existingType === mediaType) {
      if (mediaType === 'video') {
        existingMedia.src = mediaSrc
      } else {
        existingMedia.src = mediaSrc

        if (activeMedia.dataset.mediaSrcset) {
          existingMedia.srcset = activeMedia.dataset.mediaSrcset
        }

        existingMedia.alt = mediaAlt
        existingMedia.width = activeMedia.dataset.mediaWidth || 800
        existingMedia.height = activeMedia.dataset.mediaHeight || 800
      }
    } else {
      featuredWrapper.innerHTML = ''

      if (mediaType === 'video') {
        const video = document.createElement('video')

        video.id = 'featuredMedia'
        video.src = mediaSrc
        video.autoplay = true
        video.muted = true
        video.loop = true
        video.style.cssText =
          'width: 100%; height: 100%; object-fit: cover;'
        video.loading = 'eager'

        featuredWrapper.appendChild(video)
      } else {
        const img = document.createElement('img')

        img.id = 'featuredMedia'
        img.src = mediaSrc

        if (activeMedia.dataset.mediaSrcset) {
          img.srcset = activeMedia.dataset.mediaSrcset
        }

        img.alt = mediaAlt
        img.width = activeMedia.dataset.mediaWidth || 800
        img.height = activeMedia.dataset.mediaHeight || 800
        img.loading = 'eager'
        img.fetchPriority = 'high'

        featuredWrapper.appendChild(img)
      }
    }
  }

  /*
   * updateFeatured controls whether the featured image should be changed.
   * It is disabled during initialisation because the correct image is
   * already present in the HTML and loading at high priority.
   */
  function updateVisibleMedia(updateFeatured = true) {
    visibleMedia = Array.from(medias).slice(
      startIndex,
      startIndex + visibleCount
    )

    updateDisplay(updateFeatured)
  }

  function updateDisplay(updateFeatured = true) {
    medias.forEach(media => {
      media.style.display = 'none'
      media.classList.remove('active-image')
    })

    visibleMedia.forEach((media, index) => {
      media.style.display = 'block'

      if (index === activeIndex - startIndex) {
        media.classList.add('active-image')
      }
    })

    if (totalMedia > visibleCount) {
      if (btnUp) btnUp.style.display = 'block'
      if (btnDown) btnDown.style.display = 'block'
    } else {
      if (btnUp) btnUp.style.display = 'none'
      if (btnDown) btnDown.style.display = 'none'
    }

    if (updateFeatured) {
      updateFeaturedMedia()
    }

    updateCounter()
  }

  medias.forEach((media, idx) => {
    media.addEventListener('click', function() {
      activeIndex = idx
      updateDisplay()

      const mediaSelectedEvent = new CustomEvent('mediaSelected', {
        detail: {
          mediaIndex: idx,
          mediaSrc: media.dataset.mediaSrc
        }
      })

      document.dispatchEvent(mediaSelectedEvent)
    })
  })

  function nextMedia() {
    if (activeIndex < totalMedia - 1) {
      activeIndex++

      if (
        activeIndex >= startIndex + visibleCount &&
        startIndex + visibleCount < totalMedia
      ) {
        startIndex++
        updateVisibleMedia()
      } else {
        updateDisplay()
      }
    } else {
      activeIndex = 0
      startIndex = 0
      updateVisibleMedia()
    }

    const activeMedia = medias[activeIndex]

    if (activeMedia) {
      const mediaSelectedEvent = new CustomEvent('mediaSelected', {
        detail: {
          mediaIndex: activeIndex,
          mediaSrc: activeMedia.dataset.mediaSrc
        }
      })

      document.dispatchEvent(mediaSelectedEvent)
    }
  }

  function prevMedia() {
    if (activeIndex > 0) {
      activeIndex--

      if (activeIndex < startIndex && startIndex > 0) {
        startIndex--
        updateVisibleMedia()
      } else {
        updateDisplay()
      }
    } else {
      activeIndex = totalMedia - 1
      startIndex = Math.max(0, totalMedia - visibleCount)
      updateVisibleMedia()
    }

    const activeMedia = medias[activeIndex]

    if (activeMedia) {
      const mediaSelectedEvent = new CustomEvent('mediaSelected', {
        detail: {
          mediaIndex: activeIndex,
          mediaSrc: activeMedia.dataset.mediaSrc
        }
      })

      document.dispatchEvent(mediaSelectedEvent)
    }
  }

  if (btnDown) btnDown.addEventListener('click', nextMedia)
  if (btnUp) btnUp.addEventListener('click', prevMedia)
  if (btnNext) btnNext.addEventListener('click', nextMedia)
  if (btnPrev) btnPrev.addEventListener('click', prevMedia)

  document.addEventListener('variantSelected', function(e) {
    const variantImage = e.detail.variantImage

    if (variantImage) {
      const matchingMediaIndex =
        findMatchingMediaByVariantImage(variantImage)

      if (matchingMediaIndex !== -1) {
        setActiveMedia(matchingMediaIndex)
      }
    }
  })

  window.productMediaSetActiveMedia = setActiveMedia
  window.productMediaFindMatchingMedia =
    findMatchingMediaByVariantImage

    // Start the gallery at the image already rendered by Liquid.
  const initialMedia = featuredWrapper?.querySelector('#featuredMedia')
  const initialMediaSrc = initialMedia?.getAttribute('src')

  const initialMediaIndex = initialMediaSrc
    ? Array.from(medias).findIndex(
        media => media.dataset.mediaSrc === initialMediaSrc
      )
    : -1

  if (initialMediaIndex !== -1) {
    activeIndex = initialMediaIndex
    startIndex = Math.max(0, activeIndex - visibleCount + 1)
  }

  // Preserve the initial image and synchronise its thumbnail and counter.
  updateVisibleMedia(false)
})